export const PUBLICATION_COMMENTS_CONTENT_CONSTS = {
  hidePublication: 'Скрыть текст',
  loading: 'Загрузка...',
  showPublication: 'Показать текст'
}
